import { Button, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, CircularProgress, Typography } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { DocumentContext } from '../Contexts/DocumentContext';
import { postRequest, getDocumnetBlob } from "../Helpers/RequestHelper";
import { saveAs } from 'file-saver';
import JSZip from 'jszip';

const DocumentsPage = () => {
    const useStyles = makeStyles(theme => ({
        header: {
            backgroundColor: '#152740',
            fontSize: 16,
            color: 'white',
            fontWeight: 'bold',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        rows: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover
            }
        },
        rowCell: {
            fontSize: 14
        },
        searchBar: {
            width: '50%',
            float: 'right'
        },
        searchText: {
            fontSize: 16
        },
        buttonProgress: {
            color: '#152740',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12
        }
    }));

    const history = useHistory();

    const classes = useStyles();

    const { docs, getSearchedDocs, setDocsDownloaded } = useContext(DocumentContext);
    const [searchedDocs, setSearchedDocs] = useState([]);
    const [sort, setSort] = useState("-dateCon");
    const [loading, setLoading] = useState(false);
    const [docLoading, setDocLoading] = useState(false);

    // useEffect(() => {
    //     getDocs();
    // }, []);

    // useEffect(() => {
    //     setRefreshCount(refreshCount + 1);
    //     if (refreshCount < 2) {
    //         if (localStorage.getItem("token") === '') {
    //             history.replace('/portal');
    //             return;
    //         }

    //         console.log(docs);

    //         getDocs()
    //             .then(function (doen) {
    //                 setLoading(false);
    //                 setSearchedDocs([...getSearchedDocs('')]);
    //             })
    //             .catch(function (error) {
    //                 if (error === "Force password change") {
    //                     history.replace('/choosepassword');
    //                     setLoading(false);
    //                     return;
    //                 }

    //                 setLoading(false);
    //                 history.replace('/portal');

    //             });

    //     }

    // }, [docs]);

    useEffect(() => {
        if (localStorage.getItem("token") === "") {
            history.replace('/login');
            return;
        }
        if (docs.length === 0) {
            var token = localStorage.getItem("token");
            var getRequest = {
                fieldData: {
                    FirstName: "Getting doc details"
                },
                script: "GetUserCorrespondanceDetails",
                "script.param": JSON.stringify({ token })
            };
            setLoading(true);
            postRequest(getRequest)
                .then(function (result) {
                    setLoading(false);
                    console.log('downloaded');
                    if (result.code === 200) {
                        var downloaded = result.data;

                        downloaded.map(doc => {
                            var [day, month, year] = doc.date.split('/');
                            doc["dateCon"] = new Date(year, month, day).getTime() / 1000;
                            return true;
                        });

                        console.log(downloaded);

                        setDocsDownloaded(downloaded);
                        setSearchedDocs([...downloaded])
                        return;

                    }

                    if (result.code === 401) {
                        history.replace('/choosepassword');
                        return;
                    }

                    history.replace('/login');
                    localStorage.setItem("token", "");
                })
                .catch(function (error) {
                    setLoading(false);
                    history.push('/login');
                    localStorage.setItem("token", "");
                });
            return;
        }

        setSearchedDocs([...docs]);

    }, []);

    // var lastDocDate = '';

    // const setLastDate = (date) => {
    //     lastDocDate = date;
    //     return true;
    // };

    const getDocument = (docID) => {
        setDocLoading(true);
        var token = localStorage.getItem("token");
        var getRequest = {
            fieldData: {
                FirstName: "Getting document"
            },
            script: "GetCorrespondanceByID",
            "script.param": JSON.stringify({ token, requestBody: { docID } })
        };

        postRequest(getRequest)
            .then(async function (result) {
                // var url = JSON.parse(result.data.url)["Patient files 01 File"];
                let urls = result.data;
                if (result.code === 200) {
                    if (urls.length === 1) {
                        let url = JSON.parse(urls[0].url)['Patient files 01 File'];
                        let filename = JSON.parse(urls[0].url)['Patient files 02 File name'];
                        var re = /(?:\.([^.]+))?$/;
                        var ext = re.exec(filename)[1];

                        setDocLoading(false);
                        if (ext !== 'pdf') {
                            url = url.replace("?RCType=EmbeddedRCFileProcessor", '?RCType=EmbeddedRCFileProcessor');

                            getDocumnetBlob(url)
                                .then(function (result) {
                                    const a = document.createElement("a");
                                    const url = window.URL.createObjectURL(result);
                                    a.href = url;
                                    a.download = filename;
                                    a.click();
                                })
                                .catch(function (error) {

                                });
                            return;
                            window.open("//" + url);
                            return;
                        }
                        url = url.replace('https://', '');
                        window.open("//" + url, "_blank");
                        return;
                    }
                    try {
                        const zip = new JSZip();
                       
                        for (let i = 0; i < urls.length; i++) {
                            // Fetch each file
                            const response = await fetch(JSON.parse(urls[i].url)['Patient files 01 File']);
                            const fileBlob = await response.blob();

                            // Extract the filename from the URL
                            const fileName = JSON.parse(urls[i].url)['Patient files 02 File name'];

                            // Add the file to the zip
                            zip.file(fileName, fileBlob);
                        }

                        // Generate the zip file
                        const zipBlob = await zip.generateAsync({ type: 'blob' });

                        // Save and initiate the download
                        saveAs(zipBlob, JSON.parse(urls[0].url)['Patient files 06 zip name']);
                        setDocLoading(false);
                        return
                    } catch (error) {
                        console.log(error);
                        setDocLoading(false);
                        return;
                    }

                }

                if (result.message === "Force password change") {
                    setDocLoading(false);
                    history.replace('/choosepassword');
                    return;
                }

                localStorage.setItem("token", "");
                history.replace('/login');
            })
            .catch(function (error) {
                setDocLoading(false);
                localStorage.setItem("token", "");
                // history.push('/login');
                console.log(error);
            });
    };

    function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }

    const sortTable = (field) => {
        setSort((sort[0] === '-') ? field : '-' + field);
    };

    return (
        <div className="documents" style={{ paddingTop: 20, paddingRight: '1%', paddingLeft: '1%', paddingBottom: 80 }}>
            <div>
                <div className={classes.searchBar}>
                    <TextField InputProps={{ classes: { input: classes.searchText } }} placeholder='Search your documents' style={{ float: 'right', paddingBottom: 20, width: '100%' }} variant='outlined' onChange={(e) => setSearchedDocs([...getSearchedDocs(e.currentTarget.value)])} />
                </div>
                <div style={{ clear: 'both' }}>
                    <Typography style={{ width: '100%', fontSize: 14, textAlign: 'left', marginBottom: 10, marginLeft: 10 }}>If you experience any issues in downloading your correspondence, please check your device settings and ensure popups are allowed from this site.<br />
                        Logout: When you have accessed your documents, please logout using the icon above. This will also happen automatically when closing the portal webpage.<br />
                        Resetting of password: If you forget your password in the future, this can easily be reset at the Portal login page using the ‘forgotten password’ link.
                    </Typography>
                </div>
            </div>
            <TableContainer style={{ width: '100%' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.header} onClick={() => sortTable('dateCon')}>
                                Date
                            </TableCell>
                            <TableCell className={classes.header} onClick={() => sortTable('fileName')}>
                                File Name
                            </TableCell>
                            <TableCell className={classes.header} align='right' style={{ paddingRight: 15 }}>
                                {/* Download */}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {
                            searchedDocs.sort(dynamicSort(sort)).map(doc => (
                                <TableRow className={classes.rows} key={doc.docID}>
                                    <TableCell className={classes.rowCell} scope='row'>
                                        {doc.date}
                                    </TableCell>
                                    <TableCell className={classes.rowCell} scope='row'>
                                        {doc.fileName}
                                    </TableCell>
                                    <TableCell className={classes.rowCell} align='right' scope='row'>
                                        <Button variant='contained' style={{ width: 80, fontSize: 12 }} onClick={() => getDocument(doc.docID, doc.fileName)} color='primary' disabled={docLoading}>Download</Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {loading && <CircularProgress size={60} className={classes.buttonProgress} />}
        </div>
    );
}

export default DocumentsPage;